jQuery(document).ready(function($) {
    // On cible la vidéo ACF
    var $video = $('.acf-product-video');
    
    if ( $video.length ) {
        // Quand la vidéo démarre
        $video.on('play', function() {
            $(this).closest('.video-block-wrapper').addClass('is-playing');
        });

        // Quand la vidéo est en pause ou terminée
        $video.on('pause ended', function() {
            $(this).closest('.video-block-wrapper').removeClass('is-playing');
        });
    }
});